// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/schweissringe/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteSchweissringeDE: PageEntry = {
  id: "example.produkte-schweissringe",
  locale: "de",
  slug: "produkte/schweissringe",
  seo: {
    title: "Schweißringe | Dietz GmbH",
    description: "Dichtungseinsatz im Motorraum eines KFZ. Umsetzung eines flexiblen Werkzeugs für verschiedenste Draht- und Ringdurchmesser. Die Masse ist ein wesentlicher Faktor für die Bauteilfun",
  },
  type: "post",
  h1: "Schweißringe",
  intro: "Dichtungseinsatz im Motorraum eines KFZ. Umsetzung eines flexiblen Werkzeugs für verschiedenste Draht- und Ringdurchmesser. Die Masse ist ein wesentlicher Faktor für die Bauteilfunktion.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_schweissringe.jpg", alt: "Schweissringe", width: 800, height: 640 }
  ],
};
